import { Flex, Box, Text, Divider } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import GradientCard from "./GradientCard";
import PayModalWithTable from "./PayModalWithTable";
import NewPriceCard from "./NewPriceCard";
import QRcodeCard from "./QrcodeCard";
import { formatTime } from "@/utils/format-time";
import { PropsWithChildren, ReactNode, useEffect, useState } from "react";
import { getGlobalPending } from "@/modules/editor/request/generator-task";

interface NewPayModalProps {
  isOpen: boolean;
  onClose(): void;
  isVip: boolean;
  expire?: number | Date;
  qrCode: ReactNode;
}

function NewPayModal(props: PropsWithChildren<NewPayModalProps>) {
  const { isOpen, onClose, isVip, expire, children, qrCode } = props;
  const [pendingTasks, setPendingTasks] = useState(0);
  useEffect(() => {
    if (isVip) return;
    getGlobalPending().then((count) => {
      setPendingTasks(count);
    });
  }, [isVip, setPendingTasks]);
  return (
    <PayModalWithTable
      isOpen={isOpen}
      onClose={onClose}
      title={isVip ? "续费「画宇宙」会员" : "开通「画宇宙」会员"}
      content={
        <Flex flexDirection="column" color="text.subtitle" fontSize="14px" mt="-10px">
          <GradientCard isVip={isVip}>
            {isVip ? (
              <>
                <Text fontSize="22px">尊贵的画宇宙会员，您好</Text>
                <Text fontSize="12px">
                  {expire ? formatTime(expire, "会员有效期截至：YYYY 年 MM 月 DD 日") : ""}
                </Text>
              </>
            ) : (
              <>
                <Text>海量生成不限次，算力加速不排队</Text>
                <Text>你所在的普通算力通道正有 {pendingTasks} 计算任务排队</Text>
              </>
            )}
          </GradientCard>
          <Divider borderColor="#404040" mt="16px" mb="12px" />
          <Text fontWeight={600} mb="12px">
            选择会员方案
          </Text>
          <Flex h="130px" justify="space-between" mb="12px">
            {children}
            {/* <Box w="143px" mr="12px" flexGrow={1}>
              <NewPriceCard
                title="当日会员试用"
                curPrice="2.8"
                periodPrice="/天"
                unitInfo="哈哈哈"
                oldPrice="0"></NewPriceCard>
            </Box>
            <Box w="143px" mr="12px" flexGrow={1}>
              <NewPriceCard
                title="当日会员试用"
                curPrice="2.8"
                periodPrice="/天"
                selected
                unitInfo="每天不到一元钱"
                oldPrice="仅可试用一次"></NewPriceCard>
            </Box>
            <Box w="143px" flexGrow={1}>
              <NewPriceCard
                title="当日会员试用"
                curPrice="2.8"
                periodPrice="/天"
                unitInfo="哈哈哈"
                oldPrice="0"></NewPriceCard>
            </Box> */}
          </Flex>
          {qrCode}
          <Text
            fontSize="12px"
            textAlign="right"
            transformOrigin="right"
            transform="scale(0.83)"
            mt="8px"
          >
            虚拟商品，不支持退款，最终解释权归计算美学所有
          </Text>
        </Flex>
      }
    />
  );
}

export default observer(NewPayModal);
